module.exports = __webpack_public_path__ + "static/media/coliseu_box_9.56ea667b.jpg";